export type LocaleCode = 'zh' | 'en' | 'zh-TW';

/**
 * 从路径中识别语言前缀（仅支持非洲百科多语言 SEO 用到的 /en 与 /zh-TW）。
 * 无前缀时返回 null，表示使用默认中文（或客户端浏览器语言检测）。
 */
export function getLangPrefix(pathname: string): 'en' | 'zh-TW' | null {
  if (pathname === '/en' || pathname.startsWith('/en/')) return 'en';
  if (pathname === '/zh-TW' || pathname.startsWith('/zh-TW/')) return 'zh-TW';
  return null;
}

/** 去掉语言前缀，返回站内原始路径（如 /en/wiki/africa/x -> /wiki/africa/x）。 */
export function stripLangPrefix(pathname: string): string {
  if (pathname.startsWith('/en/')) return pathname.slice('/en'.length);
  if (pathname === '/en') return '/';
  if (pathname.startsWith('/zh-TW/')) return pathname.slice('/zh-TW'.length);
  if (pathname === '/zh-TW') return '/';
  return pathname;
}

/**
 * 对支持多语言 URL 的页面（非洲/品牌/极地百科），返回切换到目标语言后的路径；
 * 非本地化页面返回 null，调用方应回退到仅切换 i18n 语言。
 */
export function localizedWikiPath(pathname: string, lang: LocaleCode): string | null {
  const clean = stripLangPrefix(pathname);
  if (
    !clean.startsWith('/wiki/africa') &&
    !clean.startsWith('/wiki/brand') &&
    !clean.startsWith('/wiki/polar')
  ) {
    return null;
  }
  return lang === 'zh' ? clean : `/${lang}${clean}`;
}

/** 语言代码映射到 html lang 属性值。 */
export function localeToHtmlLang(lang: LocaleCode): string {
  if (lang === 'en') return 'en';
  if (lang === 'zh-TW') return 'zh-TW';
  return 'zh-CN';
}

/** 语言代码映射到 Open Graph locale 值。 */
export function localeToOgLocale(lang: LocaleCode): string {
  if (lang === 'en') return 'en_US';
  if (lang === 'zh-TW') return 'zh_TW';
  return 'zh_CN';
}